<template>
  <div class="nebChart">
    <div :id="chartId"
      :style="containerStyle"
    ></div>
  </div>
</template>

<script>
import embed from 'vega-embed'
import { expressionFunction } from 'vega'
import { guid } from '../../helpers'

expressionFunction('suffix', function(datum, params) {
  return `${datum} ${params}`
})

export default {
  name: 'NebChart',

  props: {
    vegaConfig: {
      type: Object,
      required: true
    },
    width: {
      type: String,
      default: '200px'
    },
    height: {
      type: String,
      default: '200px'
    },
    showActions: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    chartId: null,
    vegaView: null,
    dirty: false
  }),

  computed: {
    computedConfig () {
      return Object.assign({}, this.vegaConfig, {
        "$schema": "https://vega.github.io/schema/vega-lite/v4.json",
        width: 'container',
        height: 'container'
      })
    },
    containerStyle () {
      const { width, height } = this.$props
      return {
        width,
        height
      }
    }
  },

  watch: {
    computedConfig () { this.doEmbed() },
    width () { this.$nextTick(() => { window.dispatchEvent(new Event('resize')) }) },
    height () { this.$nextTick(() => { window.dispatchEvent(new Event('resize')) }) }
  },

  methods: {
    setId () {
      return new Promise((resolve, reject) => {
        try {
          const id = `nebChart-${String(guid()).replace(/-/g, '')}`
          this.chartId = id
          resolve(id)
        } catch (err) {
          reject(err)
        }
      })
    },
    doEmbed () {
      return embed(`#${this.chartId}`, this.computedConfig, { renderer: 'svg', actions: this.showActions })
        .then(result => { this.vegaView = result.view })
    }
  },

  mounted () {
    this.setId()
      .then(() => this.doEmbed())
  }
}
</script>

<style lang="scss">
</style>
